<template>
    <div>
      <div class="pointer cannotselect margin-top-l margin-left-l " @click="popup">弹出</div>
      <popup-menu ref="child" :menuData="menuData"  @menuClick="menuClick(arguments)" >
      </popup-menu>

    </div>
</template>

<script>

import PopupMenu from '@/components/popupMenu/PopupMenu' 

export default {
  name: 'Detail',
  components: {
    PopupMenu
  },
  data() {
      return {      
        menuData:[{id:'rename',name:'重命名'},{id:'remove',name:'移动'},{id:'delete',name:'删除'}]
      }
  },
  methods : {

    popup(event) {

      this.$refs.child.show(event);
    },
    menuClick(args) {
      console.log(args)

    }


	}
}
</script>



// WEBPACK FOOTER //
// src/views/Detail.vue